import { scaleLinear } from 'd3-scale';
import { useMemo } from 'react';
import { useSvgContext } from '../../context';
import { LINEAR } from './constants';

export default function useScaleLinearX(min: any, max: any) {
  const { right, left, width } = useSvgContext();
  const tickCount = Math.floor(Math.min(max, width / 64));
  return useMemo(() => {
    const scale: any = scaleLinear()
      .domain([min, max])
      .range([left, width - right]);
    scale.type = LINEAR;
    scale.tickCount = tickCount;
    return scale;
  }, [min, max, right, left, width, tickCount]);
}
